import EmptyState from '@atlaskit/empty-state'
import PropTypes from 'prop-types'
import errorImg from '../../static/img/error-window.svg'

export default function Error({ primaryAction, maxImageHeight }) {
  return (
    <EmptyState
      description='Something went wrong'
      header='Oops!'
      imageUrl={errorImg}
      maxImageHeight={maxImageHeight}
      primaryAction={primaryAction}
    />
  )
}

Error.propTypes = {
  primaryAction: PropTypes.node,
  maxImageHeight: PropTypes.number,
}
